/*
* Current User account/profile detail view for authenticated users
*/

import * as React from 'react';
import * as _ from 'lodash';
import Moment from 'react-moment';
import { Row } from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectRequest } from 'redux-query';
import { withRouter } from 'react-router-dom';

import * as AppComp from '../common/app-component-base';
import * as AppUtilities from '../common/apputilities';
import * as ReduxQueries from '../queries';
import ApiEndpoints from '../config/apiendpoints';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { SectionField, EntityDetailSection } from '../common/entitydetail/entitydetailsection';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';

export interface IMyAccountProps extends AppComp.IAppComponentProps {
    myAccountUserDetail?: any;
}

class MyAccount extends AppComp.AppComponent<IMyAccountProps, any> {
    public constructor(props: IMyAccountProps) {
        super(props, 'app.my-account.');
    }

    public render() {
        const user = this.props.myAccountUserDetail;
        const { ...rest } = this.props;

        let sections = {
            enabled: false,
            login: new Array(),
            profile: new Array(),
            security: new Array(),
        };

        if (user) {
            sections.enabled = true;

            sections.profile.push(new SectionField({label: this.appText('profile-first-name'), singleValue: _.get(user, 'contact.firstName', '')}));
            sections.profile.push(new SectionField({label: this.appText('profile-last-name'), singleValue: _.get(user, 'contact.lastName', '')}));
            sections.profile.push(new SectionField({label: this.appText('profile-title'), singleValue: _.get(user, 'contact.title', '')}));
            sections.profile.push(new SectionField({label: this.appText('profile-signature'), singleValue: 'TODO: IMPLEMENT SIGNATURES'}));

            sections.login.push(new SectionField({label: this.appText('login-username'), singleValue: _.get(user, 'username', '')}));
            sections.login.push(new SectionField({label: this.appText('login-email'), singleValue: _.get(user, 'email', '')}));
            sections.login.push(new SectionField({label: this.appText('login-last-login'), singleValue: (<span><Moment fromNow={true}>{user.lastLogin}</Moment> (<Moment format="MM/DD/YYYY HH:mm:ssA">{user.lastLogin}</Moment>)</span>)}));

            const checked = (<input type="checkbox" checked={true} readOnly={true} />);
            const unchecked = (<input type="checkbox" checked={false} readOnly={true} />);
            const rolesList = AppUtilities.isArrayWithLength(user.roles) ? user.roles.map(c => c.name).join(', ') : this.appText('security-roles-none');

            sections.security.push(new SectionField({label: this.appText('security-active'), singleValue: user.inactive ? unchecked : checked}));
            sections.security.push(new SectionField({label: this.appText('security-locked'), singleValue: user.locked ? checked : unchecked}));
            sections.security.push(new SectionField({label: this.appText('security-roles'), singleValue: rolesList}));
        }

        const pageTitle = this.appTextPageTitle();
        const page = (
            <WhiteBoxPageSection title={pageTitle}>
                <Row>
                    <Col xs={5}>
                        <EntityDetailSection enabled={sections.enabled} fields={sections.profile} title={this.appText('profile-details')} />
                    </Col>
                </Row>

                <Row>
                    <Col xs={5}>
                        <EntityDetailSection enabled={sections.enabled} fields={sections.login} title={this.appText('login-details')} />
                    </Col>
                </Row>

                <Row>
                    <Col xs={5}>
                        <EntityDetailSection enabled={sections.enabled} fields={sections.security} title={this.appText('security-details')} />
                    </Col>
                </Row>
            </WhiteBoxPageSection>
        );

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = () => ApiEndpoints.getMyAccountUserDetailUrl();

const mapPropsToConfigs = (props) => ReduxQueries.Queries.getMyAccountUserDetailRequest(
    getApiUrl(),
    ReduxQueries.PropsAccessToken(props),
);

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(), state, props, {
        myAccountUserDetail: state.entities.myAccountUserDetail
    });
};

const MyAccountContainer = compose<any>(
    connect(mapStateToProps),
    connectRequest(mapPropsToConfigs)
  )(MyAccount);

export default withRouter(MyAccountContainer);



// WEBPACK FOOTER //
// ./src/my-account/index.tsx